import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { TRANSLATION_LANGUAGES } from "~constants/i18n";
import { RootState } from "~redux/store";

interface translationState {
    languagePreference?: TRANSLATION_LANGUAGES;
}

const initialState: translationState = {
    languagePreference: undefined,
};

// TODO: [ENG4WCP-5161] add tests
const translationSlice = createSlice({
    name: "translation",
    initialState,
    reducers: {
        updateLanguagePreference(
            _state,
            action: PayloadAction<TRANSLATION_LANGUAGES>
        ) {
            const preference = action.payload;

            return {
                languagePreference: preference,
            };
        },
    },
});

export const { updateLanguagePreference } = translationSlice.actions;

export const selectLanguagePreference = (state: RootState) =>
    state.translation.languagePreference;

export default translationSlice.reducer;
